import React, { Component } from 'react';
import { PropTypes as MobxPropTypes } from 'mobx-react';
import { Row, Col } from 'react-bootstrap';
import { Form, Input } from 'formsy-react-components';
import { withRouter } from "react-router-dom";
import { withCookies, Cookies } from 'react-cookie';
import { Heading, ContainerBox } from '../AdminStyle';
import { instanceOf } from 'prop-types';
import { LogeButtonSlim } from '../../GeneralStyle'

class ApplicationForm extends Component {
		constructor(props) {
				super(props)
				this.state = {
						application: this.props.application,
				}
		}

		componentDidUpdate(prevProps) {
			if (prevProps.application !== this.props.application)
				this.setState({ application: this.props.application })
		}

		render() {

				const application = this.state.application

				return (
						<div>
						<ContainerBox style={{maxWidth: 1200, margin: "20px auto"}}>
								<Row style={{ padding: 25, margin: 'auto' }}>
									<Heading style={{paddingLeft: 0, marginLeft: 37}}>Bewerbung: { application.objectId } </Heading>
									<div style={{ paddingLeft: 0, marginLeft: 37, borderBottom: "1px solid rgb(33,45,61,15%)", width: "25%", marginBottom: 20 }}></div>

										<Form
												className={'dashboard-form'}
												layout={'vertical'}
												validateOnSubmit={false}
												validatePristine={false}
												formNoValidate
												noValidate
										>


											<Col md={6}>
												<Input
													name="title"
													label="Titel"
													value={ application.title }
													type="text"
													disabled
												/>
											</Col>

											<Col md={6}>
												<Input
													name="firstname"
													label="Vorname"
													value={ application.firstname }
													type="text"
													disabled
												/>
											</Col>

											<Col md={6}>
												<Input
													name="lastname"
													label="Nachname"
													value={ application.lastname }
													type="text"
													disabled
												/>
											</Col>

											<Col md={6}>
												<Input
													name="birthdate"
													label="Geburtsdatum"
													value={ application.birthdate }
													type="text"
													disabled
												/>
											</Col>

											<Col md={6}>
												<Input
													name="email"
													label="EMail"
													value={ application.email }
													type="text"
													disabled
												/>
											</Col>

											<Col md={6}>
												<Input
													name="phone"
													label="Telefonnummer"
													value={ application.phone }
													type="text"
													disabled
												/>
											</Col>

											<Col md={6}>
												<Input
													name="knownMember"
													label="Bekanntes Mitglied"
													value={ application.knownMember }
													type="text"
													disabled
												/>
											</Col>

											<Col md={6}>
												<Input
													name="company"
													label="Unternehmen"
													value={ application.company }
													type="text"
													disabled
												/>
											</Col>

											<Col md={6}>
												<Input
													name="uid"
													label="UID"
													value={ application.uid }
													type="text"
													disabled
												/>
											</Col>

											<Col md={6}>
												<Input
													name="branche"
													label="Branche"
													value={ application.industry }
													type="text"
													disabled
												/>
											</Col>

											<Col md={6}>
												<Input
													name="city"
													label="Firmensitz"
													value={ application.city }
													type="text"
													disabled
												/>
											</Col>
                      <Col md={6}>
												<Input
													name="postcode"
													label="PLZ"
													value={ application.postcode }
													type="text"
													disabled
												/>
											</Col>
                      <Col md={6}>
												<Input
													name="address"
													label="Firmenanschrift"
													value={ application.address }
													type="text"
													disabled
												/>
											</Col>

                      <Col md={6}>
												<Input
													name="position"
													label="Position"
													value={ application.position }
													type="text"
													disabled
												/>
											</Col>

	                    <Col md={6}>
												<Input
													name="golfcourse"
													label="Golfclub"
													value={ application.golfcourse }
													type="text"
													disabled
												/>
											</Col>

                      <Col md={6}>
												<Input
													name="handicap"
													label="Handicap"
													value={ application.handicap }
													type="text"
													disabled
												/>
											</Col>

                      <Col md={6}>
												<Input
													name="region"
													label="Region"
													value={ application.region && `${application.region.title}, ${application.region.country.title}` }
													type="text"
													disabled
												/>
											</Col>

	                    <Col md={12} style={{ paddingTop: 35, paddingRight: 35, textAlign: "center", }}>
	                        <LogeButtonSlim
	                            hoverFontColor={"white"}
	                            onClick={() => { this.props.history.push(`/internal/admin/applications/`) }}>
	                            zurück zur Liste
	                        </LogeButtonSlim>

	                        <LogeButtonSlim
	                            hoverFontColor={"white"}
	                            onClick={() => { this.props.history.push(`/internal/admin/onboarding/` + application.objectId) }}>
	                            Bewerbung akzeptieren
	                        </LogeButtonSlim>
	                    </Col>
										</Form>
								</Row>
								</ContainerBox>
						</div>
				);
		}
}

ApplicationForm.propTypes = {
		userStore: MobxPropTypes.observableObject,
		cookies: instanceOf(Cookies).isRequired
};

export default withCookies(withRouter(ApplicationForm));



// WEBPACK FOOTER //
// /src/components/admin/Forms/ApplicationForm.js